import { render, staticRenderFns } from "./multipleChainsBlack.vue?vue&type=template&id=1abbfbe0&scoped=true&"
import script from "./multipleChainsBlack.vue?vue&type=script&lang=js&"
export * from "./multipleChainsBlack.vue?vue&type=script&lang=js&"
import style0 from "./multipleChainsBlack.vue?vue&type=style&index=0&id=1abbfbe0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abbfbe0",
  null
  
)

export default component.exports